<template>
  <div>
    <van-popup
      v-model="isshow"
      position="bottom"
      style="margin-bottom:10px;"
      @click-overlay="cancel"
    >
      <van-checkbox-group v-model="result">
        <van-checkbox v-for="(item, index) in reportlist" :key="index" :name="item">{{ item.name }}</van-checkbox>
      </van-checkbox-group>
      <p @click="submit">确认举报</p>
    </van-popup>
  </div>
</template>
<script>
import { report_index } from "../api/common";
import { report_save } from "../api/common";
import secret from "../assets/js/utils";
export default {
  data() {
    return {
      reportlist: [],
      result: [], //选中的
      isshow: ""
    };
  },
  props: ["showpopup", "products"],
  methods: {
    submit() {
      // console.log(this.result);
      if (this.result.length == 0) {
        return;
      }
      let report_id = [];
      for (let i = 0; i < this.result.length; i++) {
        report_id.push(this.result[i].id);
      }
      let params = {
        user_id: this.products[0],
        target_id: this.products[1],
        report_id,
        type: this.products[2]
      };
      console.log(params);
      let params_str = JSON.stringify(params);
      let params_Encrypt = secret.Encrypt(params_str);
      report_save({
        params: params_Encrypt
      }).then(res => {
        res = res.data;
        let res_data = JSON.parse(secret.Decrypt(res));
        // console.log(res_data);
        if (res_data.code == 1) {
          this.$toast("举报成功");
           this.$emit("cancel", false);
           this.result = [];
        } else {
          this.$toast("请重新尝试");
           this.$emit("cancel", false);
        }
      });
    },
    //点击遮罩层
    cancel() {
      this.$emit("cancel", false);
    },
    getIndex() {
      report_index({}).then(res => {
        res = res.data;
        let res_data = JSON.parse(secret.Decrypt(res));
        // console.log(res_data);
        if (res_data.code == 1) {
          this.reportlist = res_data.data;
        }
      });
    }
  },
  created() {
    this.$nextTick(() => {
      this.isshow = this.showpopup;
    });
    this.getIndex();
    this.showpopup = false
  },
  watch: {
    showpopup(val, oldval) {
      this.$nextTick(() => {
        this.isshow = val;
      });
    },
    products(val, oldval) {
      this.$nextTick(() => {
        console.log(val, oldval);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.van-popup {
  text-align: center;
  width: 80%;
  border-radius: 15px;
  .van-checkbox-group {
    .van-checkbox {
      height: 1rem;
      border-bottom: 1px solid #f7f7f7;
      line-height: 1rem;
      display: flex;
      align-items: center;
      /deep/.van-checkbox__icon {
        flex: 1 !important;
        text-align: right;
      }
      /deep/.van-checkbox__label {
        flex: 1 !important;
        text-align: left;
      }
    }
  }
  p {
    height: 1rem;
    line-height: 1rem;
    border-radius: 8px;
    color: #e54544;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/showpopup.vue